import { inviteApi, wechatApi } from '@/request';

/**
 * 邀请(卡)服务
 */
class InviteServer {
  constructor() {
    if (typeof InviteServer.instance === 'object') {
      return InviteServer.instance;
    }

    this.state = {
      invite_code: '' // 邀请码 (邀请卡开关开启才有)
    };
  }

  /**
   * 初始化获取邀请卡信息
   * @param {*} data
   * source_id 数据来源id
   * source_type 数据来源id类型：1.活动 2.落地页
   * language_type 语言类型  0.中文  1.英文
   * invite_id 邀请人id
   * invite_id_type 邀请人id类型  1.C端用户id 2.游客id 3.B端用户
   * business_uid b端用户id
   * @returns
   */
  createInvite(data = {}) {
    return inviteApi.createInvite(data).then(res => {
      if (res?.code == 200) {
        // 设置邀请码
        this.state.invite_code = res.data?.invite_code || '';
      }
      return res;
    });
  }

  createInviteItem(data = {}, options = {}) {
    return inviteApi.createInviteItem(data, options);
  }

  wechatShare(data = {}) {
    return wechatApi.wechatShare(data);
  }

  bindInvite(data = {}, options = {}) {
    return inviteApi.bindInvite(data, options)
  }
  getInviteDetailsUrl(data = {}) {
    return inviteApi.getInviteDetailsUrl(data)
  }

  getMyInviteCard(data = {}) {
    return inviteApi.getMyInviteCard(data).then(res => {
      if (res?.code == 200) {
        // 设置邀请码
        this.state.invite_code = res.data?.invite_code || '';
      }
      return res;
    });
  }
}

export default function useInviteServer() {
  if (!useInviteServer.instance) {
    useInviteServer.instance = new InviteServer();
  }

  return useInviteServer.instance;
}
